type Props = {
  visible: boolean;
  url: string;
};

const ChatModal = ({ visible, url }: Props) => {
  return (
    <div style={{ display: visible ? 'block' : 'none' }} className="chat-modal-window">
      <iframe src={url} style={{ height: '100%', width: '100%' }} title="Chat Modal" />
    </div>
  );
};

export default ChatModal;
